import { toFirstLowerCase, toFirstUpperCase } from 'infrastructure/functions';

import { deleteUnnecessaryEmptyLines } from '../helpers';

type TData = {
  whichPerson: null | string;
  otherPerson: null | string;
  reasonForCall: string[];
  callTypeExtra: [];
  callType: null | string;
  otherDetails: null | string;
};

export const generateAppendixCMessage = <T extends TData>(data: T) => {
  const {
    whichPerson,
    otherPerson,
    callType,
    callTypeExtra,
    reasonForCall,
    otherDetails,
  } = data;
  let message = '';
  const isPatient = whichPerson === 'Patient';
  const target =
    whichPerson === 'Other'
      ? toFirstLowerCase(otherPerson as string)
      : toFirstLowerCase(whichPerson as string);

  const speakWith = isPatient ? 'patient' : `${target}`;
  const speakWithUpperCase = isPatient
    ? 'Patient'
    : `${toFirstUpperCase(target)}`;

  if ((callType as unknown as string) === 'inbound') {
    message += `MA received call from ${speakWith}. `;
  }
  if ((callType as unknown as string) === 'outbound') {
    message += `MA placed call to ${speakWith}. `;
  }
  if (whichPerson) {
    message += `Spoke with ${speakWithUpperCase}. `;
  }
  if (callTypeExtra.length > 0) {
    message += `Informed ${speakWith} the call is being recorded for Quality assurance purposes. `;
  }

  if (reasonForCall.includes('Introductory Call')) {
    message += '\n';
    message += `MA introduced themselves and the program to the ${speakWith}. `;
  }
  if (reasonForCall.includes('Normal Readings')) {
    message += '\n';
    message += `MA discussed recent readings with ${speakWith}. `;
  }
  if (reasonForCall.includes('Device Troubleshoot')) {
    message += '\n';
    message += `MA discussed device issues with ${speakWith}. `;
  }
  if (reasonForCall.includes('No Readings')) {
    message += '\n';
    message += `MA discussed the importance of using their device with ${speakWith}. `;
  }
  if (reasonForCall.includes('Monthly Interaction Call')) {
    message += '\n';
    message += `MA spoke with ${speakWith} for monthly RPM follow up call. `;
  }
  if (reasonForCall.includes('Other')) {
    if ((callType as unknown as string) === 'inbound') {
      message += '\n';
      message += `MA received call from ${speakWith} regarding `;
    }
    if ((callType as unknown as string) === 'outbound') {
      message += '\n';
      message += `MA called to ${speakWith} regarding `;
    }
    message += `${otherDetails} `;
  }

  message = deleteUnnecessaryEmptyLines(message);
  return message;
};
